import React from 'react'
import ReactDOM from 'react-dom'
import 'bulma/css/bulma.min.css'
import './css/index.css'
import 'highlight.js/styles/github.css'
import App from './components/App'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'mobx-react'
import rootStore from './stores/rootStore'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faSort } from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons'

library.add(faBars, faCheckCircle, faTimesCircle, faSort)

ReactDOM.render(
  <BrowserRouter>
    <Provider {...rootStore.stores}>
      <App />
    </Provider>
  </BrowserRouter>
  ,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js